import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Data from '../ingredients.csv'
import Papa from 'papaparse'
import '../assets/css/expertMode.css'
import { useNavigate } from 'react-router-dom';

export default function ExpertMode() {

  const [data, setData] = useState([]);
  const nav = useNavigate();

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    limit: 5,
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch (Data);
      const reader = response.body.getReader();
      const result = await reader.read();
      const decoder = new TextDecoder('utf-8');
      const csvData = decoder.decode(result.value);
      const parseData = Papa.parse(csvData, {
        header: true,
        skipEmptyLines: true,
      }).data;
      const finalData = parseData.map((ele, index) => (ele.ingredients))
      setData(finalData);
    }
    fetchData();
  }, []);

  const handleDietChange = (e) => {
    const value = e.target.value;
    if (selectedDiet.includes(value)) {
      setSelectedDiet(selectedDiet.filter((item) => item !== value));
    } else {
      setSelectedDiet([...selectedDiet, value]);
    }
  };

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    if (selectedCategory.includes(value)) {
      setSelectedCategory(selectedCategory.filter((item) => item !== value));
    } else {
      setSelectedCategory([...selectedCategory, value]);
    }
  };

  const handleCuisineChange = (e) => {
    const value = e.target.value;
    if (selectedCuisine.includes(value)) {
      setSelectedCuisine(selectedCuisine.filter((item) => item !== value));
      if (excludedCuisine.includes(value)) {
        setExcludedCuisine(excludedCuisine.filter((item) => item !== value));
      }
    } else {
      setSelectedCuisine([...selectedCuisine, value]);
      if (excludedCuisine.includes(value)) {
        setExcludedCuisine(excludedCuisine.filter((item) => item !== value));
      }
    }
  };

  const handleExcludedCuisineChange = (e) => {
    const value = e.target.value;
    if (excludedCuisine.includes(value)) {
      setExcludedCuisine(excludedCuisine.filter((item) => item !== value));
      if (selectedCuisine.includes(value)) {
        setSelectedCuisine(selectedCuisine.filter((item) => item !== value));
      }
    } else {
      setExcludedCuisine([...excludedCuisine, value]);
      if (selectedCuisine.includes(value)) {
        setSelectedCuisine(selectedCuisine.filter((item) => item !== value));
      }
    }
  };

  const handlePreparationTimeChange = (e) => {
    setPreparationTime(e.target.value);
  };

  const handleHealthyScoreChange = (e) => {
    setHealthyScore(e.target.value);
  };

  const handleCaloriesCountChange = (e) => {
    const value = e.target.value;
    if (caloriesCount.includes(value)) {
      setCaloriesCount(caloriesCount.filter((item) => item !== value));
    } else {
      setCaloriesCount([...caloriesCount, value]);
    }
  };

  const handleAllergiesChange = (e) => {
    const value = e.target.value;
    if (allergies.includes(value)) {
      setAllergies(allergies.filter((item) => item !== value));
    } else {
      setAllergies([...allergies, value]);
    }
  };

  const handleRecipeCostChange = (e) => {
    setRecipeCost(e.target.value);
  };

  const clearAll = () => {
    setSelectedDiet([]);
    setSelectedCategory([]);
    setSelectedCuisine([]);
    setExcludedCuisine([]);
    setPreparationTime('0');
    setHealthyScore('0');
    setCaloriesCount([]);
    setAllergies([]);
    setRecipeCost('0');
    setSelectedIngredients([]);
    setExcludedIngredients([]);
  }

  const clearDiet = () => {
    setSelectedDiet([]);
  }

  const clearCategory = () => {
    setSelectedCategory([]);
  }

  const clearCuisine = () => {
    setSelectedCuisine([]);
  }

  const clearExclude = () => {
    setExcludedCuisine([]);
  }

  const clearTime = () => {
    setPreparationTime('0');
  }

  const clearHealth = () => {
    setHealthyScore('0');
  }

  const clearCalories = () => {
    setCaloriesCount([]);
  }

  const clearAllergies = () => {
    setAllergies([]);
  }

  const clearCost = () => {
    setRecipeCost('0');
  }

  const clearIngredient = () => {
    setSelectedIngredients([]);
    setExcludedIngredients([]);
  }

  const [selectedDiet, setSelectedDiet] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCuisine, setSelectedCuisine] = useState([]);
  const [excludedCuisine, setExcludedCuisine] = useState([]);
  const [preparationTime, setPreparationTime] = useState('0');
  const [healthyScore, setHealthyScore] = useState('0');
  const [caloriesCount, setCaloriesCount] = useState([]);
  const [allergies, setAllergies] = useState([]);
  const [recipeCost, setRecipeCost] = useState('0');
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [excludedIngredients, setExcludedIngredients] = useState([]);

  
  function display(e){
    const dataSet = {
      selectedDiet: selectedDiet,
      selectedCategory: selectedCategory,
      selectedCuisine: selectedCuisine,
      excludedCuisine: excludedCuisine,
      preparationTime: preparationTime,
      healthyScore: healthyScore,
      caloriesCount: caloriesCount,
      allergies: allergies,
      recipeCost: recipeCost,
      selectedIngredients: selectedIngredients,
      excludedIngredients: excludedIngredients,
    }
    nav(`/expert/recipes/${encodeURIComponent(JSON.stringify(dataSet))}`)
  }

  const dietOptions = [
    { id: 'Gluten_Free', value: 'Gluten Free', label: 'Gluten Free' },
    { id: 'Ketogenic', value: 'Ketogenic', label: 'Ketogenic' },
    { id: 'Vegetarian', value: 'Vegetarian', label: 'Vegetarian' },
    { id: 'Lacto-Vegetarian', value: 'Lacto-Vegetarian', label: 'Lacto-Vegetarian' },
    { id: 'Ovo-Vegetarian', value: 'Ovo-Vegetarian', label: 'Ovo-Vegetarian' },
    { id: 'Vegan', value: 'Vegan', label: 'Vegan' },
    { id: 'Pescetarian', value: 'Pescetarian', label: 'Pescetarian' },
    { id: 'Paleo', value: 'Paleo', label: 'Paleo' },
    { id: 'Primal', value: 'Primal', label: 'Primal' },
    { id: 'Low_FODMAP', value: 'Low FODMAP', label: 'Low FODMAP' },
    { id: 'Whole30', value: 'Whole30', label: 'Whole30' },
  ];

  const categoryOptions = [
    { id: 'Main_Course', value: 'main course', label: 'Main Course' },
    { id: 'Bread', value: 'bread', label: 'Bread' },
    { id: 'Marinade', value: 'marinade', label: 'Marinade' },
    { id: 'Side_Dish', value: 'side dish', label: 'Side Dish' },
    { id: 'Breakfast', value: 'breakfast', label: 'Breakfast' },
    { id: 'Fingerfood', value: 'fingerfood', label: 'Fingerfood' },
    { id: 'Dessert', value: 'dessert', label: 'Dessert' },
    { id: 'Soup', value: 'soup', label: 'Soup' },
    { id: 'Snack', value: 'snack', label: 'Snack' },
    { id: 'Appetizer', value: 'appetizer', label: 'Appetizer' },
    { id: 'Beverage', value: 'beverage', label: 'Beverage' },
    { id: 'Drink', value: 'drink', label: 'Drink' },
    { id: 'Salad', value: 'salad', label: 'Salad' },
    { id: 'Sauce', value: 'sauce', label: 'Sauce' },
  ];

  const cuisineOptions = [
    'African', 'Asian', 'American', 'British', 'Cajun', 'Caribbean', 'Chinese',
    'Eastern European', 'European', 'French', 'German', 'Greek', 'Indian',
    'Irish', 'Italian', 'Japanese', 'Jewish', 'Korean', 'Latin American',
    'Mediterranean', 'Mexican', 'Middle Eastern', 'Nordic', 'Southern',
    'Spanish', 'Thai', 'Vietnamese'
  ];

  const preparationTimeOptions = [
    { id: 'any', value: '0', label: 'Any' },
    { id: 'prep1', value: '15', label: '15 min' },
    { id: 'prep2', value: '30', label: '30 min' },
    { id: 'prep3', value: '45', label: '+45 min' },
  ];

  const healthyScoreOptions = [
    { id: 'any2', value: '0', label: 'Any' },
    { id: 'healthy', value: '80', label: 'Healthy' },
  ];

  const caloriesCountOptions = [
    { id: 'calory1', value: '200', label: '100-200' },
    { id: 'calory2', value: '400', label: '200-400' },
    { id: 'calory3', value: '401', label: '400+' },
  ];

  const allergiesOptions = [
    { id: 'Dairy', value: 'Dairy', label: 'Dairy' },
    { id: 'Egg', value: 'Egg', label: 'Egg' },
    { id: 'Gluten', value: 'Gluten', label: 'Gluten' },
    { id: 'Grain', value: 'Grain', label: 'Grain' },
    { id: 'Peanut', value: 'Peanut', label: 'Peanut' },
    { id: 'Seafood', value: 'Seafood', label: 'Seafood' },
    { id: 'Sesame', value: 'Sesame', label: 'Sesame' },
    { id: 'Shellfish', value: 'Shellfish', label: 'Shellfish' },
    { id: 'Soy', value: 'Soy', label: 'Soy' },
    { id: 'Sulfite', value: 'Sulfite', label: 'Sulfite' },
    { id: 'Tree_Nut', value: 'Tree Nut', label: 'Tree Nut' },
    { id: 'Wheat', value: 'Wheat', label: 'Wheat' },
  ];
  

  const recipeCostOptions = [
    { id: 'cost1', value: '0', label: 'Any' },
    { id: 'cost2', value: '500', label: 'Cheap' },
    { id: 'cost3', value: '501', label: 'Expensive' },
  ];


  const renderRadioOptions = (options, name, value, handleChange) => (
    options.map((option) => (
      <div key={option.id} style={{ display: 'inline-block' }}>
        <input
          type="radio"
          className="btn-check"
          name={name}
          id={option.id}
          value={option.value}
          autoComplete="off"
          checked={value === option.value}
          onChange={handleChange}
        />
        <label className="btn btn-secondary" htmlFor={option.id}>
          {option.label}
        </label>
      </div>
    ))
  );

  const renderCheckboxOptions = (options, name, values, handleChange) => (
    options.map((option) => (
      <div key={option.id} style={{ display: 'inline-block' }}>
        <input
          type="checkbox"
          className="btn-check"
          name={name}
          id={option.id}
          value={option.value}
          autoComplete="off"
          checked={values.includes(option.value)}
          onChange={handleChange}
        />
        <label className="btn btn-secondary" htmlFor={option.id}>
          {option.label}
        </label>
      </div>
    ))
  );

  return (
    <div className='ExpertMode'>
      <form encType='text/plain' className='ExpertForm' onSubmit={display}>

      <button onClick={clearAll} className='Butoon ClearAllButoon'>Clear All</button>

      <h4 style={{marginTop: '20px'}}>Diet
      <IconButton aria-label="delete" className='chotaClear' onClick={clearDiet}>
        <DeleteIcon />
      </IconButton>
      </h4>
      {dietOptions.map((option) => (
        <div key={option.id} style={{display: 'inline-block'}}>
          <input
            type="checkbox"
            className="btn-check"
            name="diet"
            id={option.id}
            value={option.value}
            autoComplete="off"
            checked={selectedDiet.includes(option.value)}
            onChange={handleDietChange}
          />
          <label className="btn btn-secondary" htmlFor={option.id}>
            {option.label}
          </label>
        </div>
      ))}
      
      
      <h4>Category
      <IconButton aria-label="delete" className='chotaClear' onClick={clearCategory}>
        <DeleteIcon />
      </IconButton>
      </h4>
      {categoryOptions.map((option) => (
        <div key={option.id} style={{display: 'inline-block'}}>
          <input
            type="checkbox"
            className="btn-check"
            name="category"
            id={option.id}
            value={option.value}
            autoComplete="off"
            checked={selectedCategory.includes(option.value)}
            onChange={handleCategoryChange}
          />
          <label className="btn btn-secondary" htmlFor={option.id}>
            {option.label}
          </label>
        </div>
      ))}
      
      <h4>Cuisine
      <IconButton aria-label="delete" className='chotaClear' onClick={clearCuisine}>
        <DeleteIcon />
      </IconButton>
      </h4>
      {cuisineOptions.map((option) => (
        <div key={option} style={{display: 'inline-block'}}>
          <input
            type="checkbox"
            className="btn-check"
            name="cuisine"
            id={option}
            value={option}
            autoComplete="off"
            checked={selectedCuisine.includes(option)}
            onChange={handleCuisineChange}
          />
          <label className="btn btn-secondary" htmlFor={option}>
            {option}
          </label>
        </div>
      ))}


      <h4>Exclude Cuisine
      <IconButton aria-label="delete" className='chotaClear' onClick={clearExclude}>
              <DeleteIcon />
            </IconButton>
      </h4>
      {cuisineOptions.map((option) => (
        <div key={option} style={{display: 'inline-block'}}>
          <input
            type="checkbox"
            className="btn-check"
            name="excludeCuisine"
            id={`${option}1`}
            value={option}
            autoComplete="off"
            checked={excludedCuisine.includes(option)}
            onChange={handleExcludedCuisineChange}
          />
          <label className="btn btn-secondary" htmlFor={`${option}1`}>
            {option}
          </label>
        </div>
      ))}

      <h4>Preparation Time
      {/* <IconButton aria-label="delete" className='chotaClear' onClick={clearTime}>
        <DeleteIcon />
      </IconButton> */}
      </h4>
      {renderRadioOptions(preparationTimeOptions, 'preparationTime', preparationTime, handlePreparationTimeChange)}

      <h4>Health Level
      {/* <IconButton aria-label="delete" className='chotaClear' onClick={clearHealth}>
        <DeleteIcon />
      </IconButton> */}
      </h4>
      {renderRadioOptions(healthyScoreOptions, 'healthyScore', healthyScore, handleHealthyScoreChange)}

      <h4>Calories Count
      {/* <IconButton aria-label="delete" className='chotaClear' onClick={clearCalories}>
        <DeleteIcon />
      </IconButton> */}
      </h4>
      {renderCheckboxOptions(caloriesCountOptions, 'caloriesCount', caloriesCount, handleCaloriesCountChange)}

      <h4>Allergies
      <IconButton aria-label="delete" className='chotaClear' onClick={clearAllergies}>
        <DeleteIcon />
      </IconButton>
      </h4>
      {renderCheckboxOptions(allergiesOptions, 'allergies', allergies, handleAllergiesChange)}

      <h4>Recipe Making Cost
      {/* <IconButton aria-label="delete" className='chotaClear' onClick={clearCost}>
        <DeleteIcon />
      </IconButton> */}
      </h4>
      {renderRadioOptions(recipeCostOptions, 'cost', recipeCost, handleRecipeCostChange)}
    

      <h4>Choose by Ingredient
      <IconButton aria-label="delete" className='chotaClear' onClick={clearIngredient}>
        <DeleteIcon />
      </IconButton>
      </h4>
      <h5>To Include</h5>

      {data.length ? (
        <Autocomplete
        multiple
        autoHighlight
        id="tags-standard"
        filterOptions={filterOptions}
        options={data}
        value = {selectedIngredients}
        onChange={(event, newValue) => {
          setSelectedIngredients(newValue)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="Multiple values"
            placeholder="Ingredients"
          />
        )}
      />
      ) : null}

      <h5>To Exclude</h5>

      {data.length ? (
        <Autocomplete
        multiple
        autoHighlight
        id="tags-standard"
        filterOptions={filterOptions}
        options={data}
        value = {excludedIngredients}
        onChange={(event, newValue) => {
          setExcludedIngredients(newValue)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="Multiple values"
            placeholder="Ingredients"
          />
        )}
      />
      ) : null}

      <button type='submit' className='Butoon'>Start Cooking</button>

      </form>
    </div>
  )
}
